import { PageLayout } from '../../PageLayout';

export const AdviseUserManagementPage = () => {
  return (
    <PageLayout
      pageTitle="Advise User Management"
      dataCy="advise-user-management-page">
      <div>Advise User Management — Coming Soon</div>
    </PageLayout>
  );
};
